import React from 'react';
import { PhoneIncoming, PhoneOutgoing } from 'lucide-react';
import { fmtPhone } from '../../lib/format.js';
import { fmtCallDuration, fmtCallTime, tzLabel } from '../../lib/callHistory.js';
import AudioPlayer from './AudioPlayer.jsx';

export const ROW_GRID = 'grid grid-cols-[2rem_1.4fr_1fr_1fr_1.6fr] items-center gap-4';

/**
 * One call-history row: checkbox, lead/phone, lead timezone, duration+direction,
 * timestamp + recording controls.
 * @param {{call: object, selected: boolean, onToggle: (id: string) => void,
 *   onOpenLead: (leadId: string) => void, onDeleteRecording: (id: string) => void,
 *   deletingId?: string|null}} props
 * @returns {JSX.Element}
 */
export default function CallRow({ call, selected, onToggle, onOpenLead, onDeleteRecording, deletingId = null }) {
  const inbound = call.direction === 'inbound';
  const phone = fmtPhone(inbound ? call.fromNumber : call.toNumber) || '--';
  const DirIcon = inbound ? PhoneIncoming : PhoneOutgoing;
  return (
    <div className={`${ROW_GRID} px-4 py-4 border-b border-white/5 hover:bg-white/[0.02]`} data-testid="call-row">
      <input
        type="checkbox"
        checked={selected}
        onChange={() => onToggle(call._id)}
        aria-label="Select call"
        className="w-4 h-4 accent-violet-500"
      />
      <div className="min-w-0">
        {call.lead ? (
          <button type="button" onClick={() => onOpenLead(call.lead._id)} className="text-sm text-white/90 hover:underline text-left truncate block">
            {call.lead.name || 'View lead'}
          </button>
        ) : (
          <div className="text-[11px] italic text-white/60">No lead found</div>
        )}
        <div className="text-violet-300 font-medium tabular-nums">{phone}</div>
      </div>
      <div className="text-sm text-white/70" data-testid="lead-tz">{tzLabel(call.leadTimezone)}</div>
      <div className="text-sm text-white/80">
        <div>{fmtCallDuration(call.durationSec)}</div>
        <div className="inline-flex items-center gap-1 text-white/70">
          <DirIcon className="w-3.5 h-3.5" /> {inbound ? 'Inbound' : 'Outbound'}
        </div>
      </div>
      <div className="text-right">
        <div className="text-xs text-white/70 mb-2">{fmtCallTime(call.createdAt)}</div>
        {call.hasRecording && (
          <AudioPlayer callId={call._id} onDelete={onDeleteRecording} deleting={deletingId === call._id} />
        )}
      </div>
    </div>
  );
}
